import { render, staticRenderFns } from "./AddBidDropdown.vue?vue&type=template&id=636f0794"
import script from "./AddBidDropdown.vue?vue&type=script&lang=js"
export * from "./AddBidDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports